<template>
	<v-text-field
		:type="type"
		:label="label"
		:placeholder="placeholder"
		:hint="hint"
		:required="required"
		:disabled="disabled"
		:readonly="readonly"
		:clearable="clearable"
		:dense="dense"
		:value="text"
		:error-count="3"
		:error-messages="errors"
		:append-icon="appendIcon"
		:prepend-icon="icon"
		:name="name"
		@input="onInput($event)"
	/>
</template>

<script>
import uuidv4 from 'uuid/v4'

export default {
	props: {
		autocomplete: {
			type: Boolean,
			default: true,
		},
		type: String,
		disabled: Boolean,
		dense: Boolean,
		readonly: Boolean,
		label: String,
		placeholder: String,
		value: [String, Number],
		required: Boolean,
		clearable: Boolean,
		hint: String,
		errors: {
			type: Array,
			default: () => [],
		},
		icon: String,
		appendIcon: String,
	},
	data() {
		return {
			name: undefined,
		}
	},
	computed: {
		text() {
			return this.value
		},
	},
	watch: {
		// @todo - Do a mixin for inputs
		// Simpliest way to be able to prevent auto-complete across browsers
		autocomplete: {
			immediate: true,
			handler() {
				this.name = uuidv4()
			},
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
	},
}
</script>
